import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import moment from "moment";

//Services
import api from "../../../service/api";

//Routes
import routes from "../../../routes/campaigns.routes";

//Components
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Main from "../../../components/Main";
import Table from "../../../components/Table";
import ModalDetails from "../../../components/ModalDetails";

//Styles
import {
    THead,
    Td,
    Th,
    ThFilterable,
    DetailsButton,
    CircleStatus
} from "./styles";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Help Data
import { serverPath } from "../../../helpers/helpersVariables"

//Assets
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import colors from "../../../assets/css/colors";

//Utils
import { translateStatus } from "../../../utils/translate/status";
import { translatePaymentType } from "../../../utils/translate/paymentType";
import Animation from "../../../components/Animation/animation";

const Donations = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [donationsList, setDonationsList] = useState<any>([]);
    const [donationSelected, setDonationSelected] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [searchType, setSearchType] = useState("");
    const [filterGraficButton, setFilterGraficButton] = useState(2);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    const [exportVariable, setExportVariable] = useState("")
    const [datesForExport, setDatesForExport] = useState({
        fdate: "",
        ldate: ""
    })

    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);

    const login = useSelector((state: {login: any}) => state.login);

    useEffect(() => {
        
        const getDonationsAtApi = async () => {
            let data = [];
            
            if(filterGraficButton === 2){
                const response = await api.get("/transaction/list", {
                    params: {
                        campanha: true,
                        bid: login.user.branchs.sellerOwnerPayId,
                        week: true,
                        page: page
                    }
                });
                
                data = response.data;
                
                setExportVariable("week")
            }
            
            if(filterGraficButton === 1){
                const response = await api.get("/transaction/list", {
                    params: {
                        campanha: true,
                        bid: login.user.branchs.sellerOwnerPayId,
                        month: moment().month() + 1,
                        page: page
                    }
                });
                
                data = response.data;
                
                setExportVariable("month")
            }
            
            if(filterGraficButton === 0 && startDate !== null && endDate !== null){
                const response = await api.get("/transaction/list", {
                    params: {
                        campanha: true,
                        bid: login.user.branchs.sellerOwnerPayId,
                        fdate: moment(startDate).format("YYYY-MM-DD"),
                        ldate: moment(endDate).format("YYYY-MM-DD"),
                        page: page
                    }
                });
                
                data = response.data;
                
                setExportVariable("fdate")
                setDatesForExport({
                    fdate: moment(startDate).format("YYYY-MM-DD"),
                    ldate: moment(startDate).format("YYYY-MM-DD")
                })
            }
            
            if(data.Transactions !== undefined){
                setDonationsList(data.Transactions);
                setMaxPage(data.pageCount);
            } 
            
            else if (data.Campanhas !== undefined){
                setDonationsList(data.Campanhas);
                setMaxPage(data.pageCount);
            }
        }
        
        if(page !== 0 && login.user.branchsId !== null && debouncedSearchTerm === ""){
            getDonationsAtApi();
        }

    }, [page, filterGraficButton, startDate, endDate, login.user.branchsId, debouncedSearchTerm]);

    useEffect(() => {
        setIsLoading(true);
        
        const timerId = setTimeout(() => {
            setIsLoading(false);
            setPage(1);
            verifySearch(searchTerm)
        }, 2000);
    
        return () => {
            clearTimeout(timerId);
        }
    }, [searchTerm]);

    useEffect(() => {
        const getDonationsFilteredAtApi = async () => {
            const { data } = await api.get("transaction/list", {
                params: {
                    campanha: true,
                    bid: login.user.branchs.sellerOwnerPayId,
                    search: debouncedSearchTerm,
                    filter: searchType,
                    page: page
                }
            });
            
            setExportVariable("search")
            setMaxPage(data.pageCount);
            setDonationsList(data.Campanhas);
        }
        
        if(debouncedSearchTerm !== ""){
            getDonationsFilteredAtApi();
        }
    }, [debouncedSearchTerm, page]);

    const circleColorDefiner = (status: string) => {
        switch (status){
          case "succeeded":
            return colors.green;
          
            case "pending":
            return colors.yellow;
          
            case "failed":
            return colors.redDark;
          
            default:
            return colors.gray;
        }
    }

    function verifySearch(word: string) {
        switch(word){
            case "Aprovada":
              return setDebouncedSearchTerm("succeeded");
  
            case "Falhada": 
              return setDebouncedSearchTerm("failed");
  
            case "Cancelada": 
              return setDebouncedSearchTerm("canceled");

              default:
                return setDebouncedSearchTerm(searchTerm);
        }
    }

    const tableContentGenerator = () => {
        return donationsList?.map((donation: any) => {
            let date = moment(donation.tr_created_at).add(3 ,"hours").format("DD/MM/YYYY").toLocaleString(); //corringindo UTC Timezone
            
            return(
                <tr key={donation.tr_id} style={{ height: 67 }}>
                    <Td><span>R${parseFloat(donation.tr_amount).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
                    <Td><span>R${parseFloat(donation.tr_fees).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
                    <Td><span>R${(parseFloat(donation.tr_amount) - parseFloat(donation.tr_fees)).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
                    <Td>
                        <div className="d-flex align-items-start justify-content-start">
                        <CircleStatus color={circleColorDefiner(donation.tr_status)}/>
                        {translateStatus(donation.tr_status)}
                        </div>
                    </Td>
                    <Td>{donation.tr_description}</Td>
                    {/* <Td>{donation.dueDate}</Td> */}
                    <Td>{date}</Td>
                    <Td>{translatePaymentType(donation.tr_paymentType)}</Td>
                    <Td style={{paddingTop: 9}}>
                        <DetailsButton onClick={() => handleDetailsClick(donation)}>
                            ver detalhes
                        </DetailsButton>
                    </Td>
                </tr>
            )
        })
    }


    const handleClickExport = async () => {
        if(exportVariable === "fdate") {
            const { data } = await api.get("/transaction/list", {
                params: {
                    campanha: true,
                    bid: login.user.branchs.sellerOwnerPayId,
                    exportFilter: true,
                    fdate: datesForExport.fdate,
                    ldate: datesForExport.ldate
                }
            });
            
            window.open("${serverPath}/${data}")
        } else {
            const { data } = await api.get("/transaction/list", {
                params: {
                    campanha: true,
                    bid: login.user.branchs.sellerOwnerPayId,
                    exportFilter: true,
                    [exportVariable]: debouncedSearchTerm === "" ? true : debouncedSearchTerm
                }
            });
            
            window.open("${serverPath}/${data}")
        }
    }

    const handleDetailsClick = async (transaction: any) => {
    try {
      const response = await api.get("/transaction/list", {
        params: {
          transactionNumber: transaction.tr_transactionNumber,
        }
      });
      const newData: object = response.data.TransactionsDetails;
      const buyer = response.data.buyer;
      const transacionCompleteData = {...transaction, ...newData, ...buyer[0]};
      
      setDonationSelected(transacionCompleteData);
      openModal("details");
    } catch (error) {

    }
  }

    return(
        <Container fluid>
            <ModalDetails id="details" data={donationSelected}/>
            <Main className="column-content">
                <Header title="Campanhas" subTitle="Crie e gerencie campanhas e acompanhe as doações" subTitleWidth={271}/>
                <NavTabs tabs={routes}/>

                <Table
                    page={page}
                    maximumPage={maxPage}
                    setPage={setPage}
                    showExportButton={login.user.groups.cm1e} //login.user.groups.cm1e
                    handleExport={handleClickExport}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    filterGraficButton={filterGraficButton}
                    setFilterGraficButton={setFilterGraficButton}
                    filter={true}
                    searchAndFilter={true}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    setTypeSearch={setSearchType}
                    arrayForSelect={["campanha", "status"]}
                >
                    <THead>
                        <tr>
                            <Th>Valor Bruto</Th>
                            <Th>Taxa</Th>
                            <Th>Valor Líquido</Th>
                            <ThFilterable>
                                <div>Status</div>
                                <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                                    <img src={upArrow} alt="seta para cima" />
                                    <br />
                                    <img src={downArrow} alt="seta para baixo" />
                                </div>
                            </ThFilterable>
                            <Th>Descrição</Th>
                            <Th>Data da venda</Th>
                            <Th>MÉTODO DE PAGAMENTO</Th>
                            <Th></Th>
                        </tr>
                    </THead>
                    {
                        isLoading 
                        ? <Animation/>
                        : <tbody>
                            {tableContentGenerator()}
                        </tbody>
                    }
                </Table>
            </Main>
        </Container>
    )
}

export default Donations;